module.exports = __webpack_public_path__ + "static/img/img_sp.28405b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img_sp.jpg
// module id = 170
// module chunks = 1